import styled from 'styled-components'

export const ConversationOrderSummaryLinesStyled = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto auto;
  align-items: center;
  column-gap: ${(props) => props.theme.space.xlarge};
  row-gap: ${(props) => props.theme.space.small};
`
